/** Минимум для показа метрик LTI в строке обзора рынка. */
export const LTI_DISCLOSURE_MIN_COMPANIES = 3;
export const LTI_DISCLOSURE_MIN_RECORDS = 5;

export function meetsLtiDisclosureMinimum(
  records: Array<{ company_id?: string | null }>,
): boolean {
  const companies = new Set(
    records
      .map((record) => String(record.company_id ?? '').trim())
      .filter(Boolean),
  ).size;
  return companies >= LTI_DISCLOSURE_MIN_COMPANIES && records.length >= LTI_DISCLOSURE_MIN_RECORDS;
}
